export const columns = [
    { 
      field: 'masterProductId', 
      header: 'Master ID',
      sizes: { xs: 1 }
    },
    { 
      field: 'productId', 
      header: 'ID',
      sizes: { xs: 1 }
    },
    { 
      field: 'refId', 
      header: 'Codigo de Producto',
      sizes: { xs: 2 }
    },
    {
      field: 'colorName',
      header: 'Color',
      sizes: { xs: 1 }
    },
    {
      field: 'description',
      header: 'Descripcion',
      sizes: { xs: 6 },
      sx: { flexGrow: 1 }
    },
    {
      field: 'quantity',
      header: 'Cantidad',
      type: 'number',
      sizes: { xs: 1 }
    }
];

export const headers = [
    'Codigo de Producto',
    'Descripcion',
    'Color',
    'Cantidad',
];

export const keyColumns = [
    'refId',
    'description',
    'colorName',
    'quantity',
];

export const title = 'Inventario';

export const model = 
{
  WarehouseId: 0,
  MasterProductId: 0,
  ProductId: 0,
  RefId: "",
  ColorCode: "",
  ColorName: "",
  Description: "",
  Quantity: 0
}
